module.exports = __webpack_public_path__ + "static/media/flying-nerd-apple-3-x@3x.6a506bfb.png";